
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/product-enquiry",
      function () {
        return require("private-next-pages/india/product-enquiry.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/product-enquiry"])
      });
    }
  